import { attach } from 'effector';

import { api } from '@shared/api/api';

const completeLoginFx = attach({ effect: api.auth.loginComplete });

export { completeLoginFx };
